import React, { useState, createElement } from 'react'
import ReactDom from 'react-dom'
import { Button, Modal, Form, Radio } from 'tea-component';
import './index.scss'
enum timeScaleOptions {
  _5MIN = '5',
  _10MIN = '10',
  _60MIN = '60'
}
const { _5MIN, _10MIN, _60MIN } = timeScaleOptions;
interface DownloadOptions {
  visible?: boolean,
  options: {
    timeScale: {
      show: {
        [key in timeScaleOptions]: boolean
      },
      disabled: {
        [key in timeScaleOptions]: boolean
      },
      default: string,
    }
    sort?: {
      default?: 0 | 1,//降序、升序
    }
  }
  onConfirm?: (formValue) => void,
  onExited?: () => void;
  formatMessage?: (val: any) => string
}
const DownloadOptionsModal = (props: DownloadOptions) => {
  const { onConfirm, onExited, options, visible } = props;
  // const { formatMessage } = useIntl();
  const formatMessage = props.formatMessage || function (val) {
    return val.id
  };
  const [showModal, setShowModal] = useState(visible || false);
  const [formValue, setFormValue] = useState<any>({
    timeScale: options.timeScale.default || _5MIN,
    sort: options?.sort?.default || 0,
  });

  return <Modal
    visible={showModal}
    className={'download_setting_modal'}
    caption={formatMessage({ id: 'realtime_info_download_settings' })}
    onClose={() => setShowModal(false)}
    onExited={() => onExited && onExited()}
    maskClosable
  >
    <Modal.Body>
      <Form
        className={'download_setting_form'}
      >
        <Form.Item
          label={<span className='download-text'>{formatMessage({ id: 'realtime_info_download_time' })}</span>}
          className={'download_setting_form_item'}
        >
          <Radio.Group
            value={formValue.timeScale}
            onChange={(val => setFormValue({ ...formValue, timeScale: val }))}>
            {options.timeScale.show[_60MIN] &&
              <Radio name={_60MIN} disabled={options.timeScale.disabled[_60MIN]}>
                {formatMessage({ id: 'realtime_info_download_by_hour' })}
              </Radio>}
            {options.timeScale.show[_10MIN] &&
              <Radio name={_10MIN} disabled={options.timeScale.disabled[_10MIN]}>
                {formatMessage({ id: 'realtime_info_download_by_10_min' })}
              </Radio>}
            {options.timeScale.show[_5MIN] &&
              <Radio name={_5MIN} disabled={options.timeScale.disabled[_5MIN]}>
                {formatMessage({ id: 'realtime_info_download_by_5_min' })}
              </Radio>}
          </Radio.Group>
        </Form.Item>
        {props.options.sort &&
          <Form.Item
            label={<span className='download-text'>{formatMessage({ id: 'realtime_info_download_time' })}</span>}
            className={'download_setting_form_item'}
          >
            <Radio.Group
              value={'' + formValue.sort}
              onChange={(val => setFormValue({ ...formValue, sort: parseInt(val) }))}>
              <Radio name={'1'}>
                {formatMessage({ id: 'realtime_info_download_sort_up' })}
              </Radio>
              <Radio name={'0'}>
                {formatMessage({ id: 'realtime_info_download_sort_down' })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        }
      </Form>
    </Modal.Body>
    <Modal.Footer>
      <Button type="primary" onClick={() => { onConfirm && onConfirm(formValue); setShowModal(false); }}>
        {formatMessage({ id: 'menu_confirm' })}
      </Button>
      <Button type="weak" onClick={() => setShowModal(false)}>
        {formatMessage({ id: 'menu_cancel' })}
      </Button>
    </Modal.Footer>
  </Modal>
}
const showByApi = (props: DownloadOptions): Promise<void> => {
  return new Promise(function (resolve) {
    var el = document.createElement("div");
    ReactDom.render(
      // @ts-ignore
      createElement(DownloadOptionsModal, {
        ...props,
        visible: true,
        onConfirm: function (val) {
          props.onConfirm && props.onConfirm(val);
          return resolve(val);
        },
        onExited: function () {
          props.onExited && props.onExited();
          ReactDom.unmountComponentAtNode(el);
        }
      })
      , el)
  })
}
export default DownloadOptionsModal;
export { showByApi, DownloadOptions };
